import { Component, HostListener, Input, OnChanges, SimpleChanges, EventEmitter, OnDestroy, OnInit } from '@angular/core'; 
import { Router } from '@angular/router'; 
import { UploadedFile } from '../../../../core/interfaces/file-upload-interfaces';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { RecentUploadsService } from '../../../../core/services/recent-uploads.service';
import { CommonModule } from '@angular/common';
import { UploadedFileComponent } from "../../../auth/components/onboarding/uploaded-file/uploaded-file.component";
import { FileUploadHelperService } from '../../../../core/services/file-upload-helper.service';
import { PrimaryButtonComponent } from '../../../../shared/components/primary-button/primary-button.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-location-file-upload',
  standalone: true,
  imports: [TranslocoPipe, CommonModule, UploadedFileComponent, PrimaryButtonComponent],
  templateUrl: './location-file-upload.component.html',
  styleUrl: './location-file-upload.component.css'
})
export class LocationFileUploadComponent implements OnInit, OnChanges, OnDestroy {
  @Input() toast!: ToastComponent;
  @Input() showListOfRecentUploadsAfterUpload: boolean = false;

  private hasNavigated = false;
  private uploadCompletedSubscription?: Subscription;

  get listOfRecentUploads(): UploadedFile[] {
    return this.recentUploads.getLastUploads(this.fileUploadHelper.getTotalUploadingNumber());
  }

  constructor(private recentUploads: RecentUploadsService, private translocoService: TranslocoService, protected fileUploadHelper: FileUploadHelperService, private router: Router) { }

  ngOnInit(): void {
    this.uploadCompletedSubscription = this.fileUploadHelper.allUploadsCompleted$.subscribe(result => {
      if (result.success && !this.hasNavigated) {
        this.hasNavigated = true;
        setTimeout(() => {
          this.router.navigate(['/archive']);
        }, 500); 
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.toast) {
      this.fileUploadHelper.attachToast(this.toast);
    }
  }

  ngOnDestroy(): void {
    if (this.uploadCompletedSubscription) {
      this.uploadCompletedSubscription.unsubscribe();
    }
  }

  isUploadActive() {
    return this.recentUploads.hasPendingUploads();
  }

  stopClicked(id: number) {
    if (!this.recentUploads.stopUpload(id)) {
      return;
    }

    this.toast.showToast(this.translocoService.translate("shared.file_upload.canceled"), this.translocoService.translate("shared.file_upload.stopped"), "warning", 4000, false);

  }

  // Warn user if trying to leave while upload is in progress
  @HostListener('window:beforeunload', ['$event'])
  preventNavigation(event: BeforeUnloadEvent) {
    var isUploading = this.recentUploads.hasPendingUploads();
    if (isUploading) {
      event.preventDefault();
    }
  }
}
